/**
 * Global State
 * 
 * Manages application-wide state that doesn't belong to specific features.
 * This includes loading states, global errors, notifications, and other cross-cutting concerns.
 */

export interface GlobalState {
    /**
     * Set of action types currently in loading state
     * Used to track multiple concurrent operations
     */
    loadingActions: Set<string>;

    /**
     * Global error state (optional, for future use)
     */
    error: string | null;

    /**
     * Additional global state can be added here:
     * - notifications: Notification[]
     * - breadcrumbs: Breadcrumb[]
     * - theme: ThemeConfig
     * - etc.
     */
}

export const initialGlobalState: GlobalState = {
    loadingActions: new Set<string>(),
    error: null
};
